import { render, staticRenderFns } from "./RewardsStats.vue?vue&type=template&id=28d39672&scoped=true"
import script from "./RewardsStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardsStats.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RewardsStats.vue?vue&type=style&index=0&id=28d39672&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d39672",
  null
  
)

/* custom blocks */
import block0 from "./RewardsStats.vue?vue&type=custom&index=0&blockType=svg&xmlns=http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&xmlns%3Axlink=http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink&version=1.1&width=256&height=256&viewBox=0%200%20256%20256&xml%3Aspace=preserve"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilmCollectionRewardCard: require('/builds/gala-games/gala-film/gala-film/src/components/FilmCollection/Overview/FilmCollectionRewardCard.vue').default})
